export default function focusAndScroll(target: React.RefObject<HTMLDivElement>, yOffset = window.innerHeight / 2) {
  target?.current && target.current.focus({ preventScroll: true });
  target?.current &&
    window.scrollTo({
      top: target.current.getBoundingClientRect().top + window.scrollY - yOffset,
      behavior: "smooth",
    });
}
